import { EventRow } from './logger.event-row';
import { loggerConstants } from 'app/logger/logger.constants';

export class ResourceCreateEvent extends EventRow {
    constructor(
        resourceName: string,
        resourceId: string,
        resourceType: string,
        subscriptionId: string,
        success: boolean,
        properties?: Record<string, string>
    ) {
        super(
            loggerConstants.Event_ResourceCreate, {
                ['resourceName']: resourceName,
                ['resourceId']: resourceId,
                ['resourceType']: resourceType,
                ['subscriptionId']: subscriptionId,
                ['status']: success ? 'success' : 'failed',
                ['source']: 'studio',
                ...properties
            }
        );
    }
}
